module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-normal-tiny.ed22f473.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-normal-tiny.png
// module id = 2652
// module chunks = 11